import CryptoJS from "crypto-js";

export const FILE_HASH_HEADER = "X-File-Hash";

function arrayBufferToWordArray(arrayBuffer: ArrayBuffer) {
  const u8 = new Uint8Array(arrayBuffer);
  const len = u8.length;
  const words: number[] = [];
  for (let i = 0; i < len; i++) {
    words[i >>> 2] |= u8[i] << (24 - (i % 4) * 8);
  }
  return CryptoJS.lib.WordArray.create(words, len);
}

/** 文件 MD5，小写 hex，与后端验签约定一致 */
export async function computeFileMd5Hex(file: Blob): Promise<string> {
  const buffer = await file.arrayBuffer();
  return CryptoJS.MD5(arrayBufferToWordArray(buffer))
    .toString(CryptoJS.enc.Hex)
    .toLowerCase();
}

/** 从 FormData 中取 file 字段（须为有效 Blob/File） */
export function extractFileFromFormData(
  formData: FormData,
  fieldName = "file"
): File | Blob | null {
  const value = formData.get(fieldName);
  if (!value || typeof value === "string") {
    return null;
  }
  if (value instanceof Blob && value.size > 0) {
    return value;
  }
  return null;
}

export function isFormDataUpload(data: unknown): data is FormData {
  return typeof FormData !== "undefined" && data instanceof FormData;
}
